






























































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import EditQuotationModal from "@/components/Quotation/Edit.vue";
import { Client, Quotation } from "@/models";
import { currentUserStore } from "@/store/typed";
import StatusBadge from "@/components/Quotation/StatusBadge.vue";

import Percent from "@/filters/Percent";
import QuotationCode from "@/filters/QuotationCode";

@Component({
  filters: { Percent, QuotationCode },
  components: { DataTable, Paginator, EditQuotationModal, StatusBadge },
})
export default class QuotationTable extends Vue {
  @Prop({ required: true }) readonly items!: Quotation[];
  @Prop({ required: true }) readonly hasFilters!: boolean;
  @Prop({ required: true }) readonly loading!: boolean;
  @Prop({ required: true }) readonly meta!: any;
  @Prop({
    default: () => {
      return null;
    },
  })
  readonly client: Client | null;

  @Ref() editModal!: EditQuotationModal;

  get hasItems() {
    return this.items && this.items.length > 0;
  }

  onPageChange(page: number) {
    this.$emit("page-change", page);
  }

  get columns() {
    let columns = [];
    columns.push({ name: "status", label: "Status" });
    columns.push({ name: "code", label: "Number" });
    columns.push({ name: "name", label: "Project name" });
    columns.push({ name: "createdAt", label: "Date" });
    columns.push({ name: "lastRevision.grandTotal", label: "Total" });
    columns.push({ name: "actions", label: "" });
    return columns;
  }

  openCreateModal() {
    this.editModal.create(currentUserStore.company, this.client);
  }

  onCreated(item: Quotation) {
    this.$emit("created", item);
  }

  onUpdated(item: Quotation) {
    this.$emit("updated", item);
  }

  onOpenDetail(item: Quotation) {
    this.$emit("open-detail", item);
  }
}
